import React, { useState, useEffect } from 'react';
import { ArrowUpCircle } from 'lucide-react';

/**
 * A button component that appears when the user scrolls down and, when clicked,
 * smoothly scrolls the page back to the top.
 */
const BackToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button if scrolled down more than 300px
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll effect
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 bg-accent-main text-white p-3 rounded-full shadow-lg
        hover:bg-accent-hover transition-all duration-300 z-50
        ${showButton ? 'opacity-100 scale-100' : 'opacity-0 scale-0 pointer-events-none'}`}
      aria-label="Back to top"
    >
      <ArrowUpCircle className="w-6 h-6" />
    </button>
  );
};

export default BackToTopButton;
